
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { ReleaseType, ReleasePayloadType } from "@/common/types/release";

export async function releaseList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `release/list${queryString}`
    );
}

export async function releaseGet(
    release_id: string
) {
    return await clientAxios.get(
        `release/${release_id}/show`
    );
}

export async function releaseAdd(
    payload: ReleasePayloadType
) {
    return await clientAxios.post(
        `release/create`,
        payload
    );
}

export async function releasePatch(
    release_id: string,
    payload: Partial<ReleaseType>
) {
    return await clientAxios.patch(
        `release/${release_id}/patch`,
        { payload }
    );
}

export async function releaseDel(
    release_id: string,
) {
    return await clientAxios.del(
        `release/${release_id}/delete`,
    );
}
